import React from 'react'
import {Icon} from '@chakra-ui/react'

const PlusIcon = (props) => {
    return (
        <Icon viewBox="0 0 26 25" fill="none" {...props}>
            <path
                d="M13.1267 24.92C12.5767 24.92 12.1267 24.47 12.1267 23.92V1C12.1267 0.45 12.5767 0 13.1267 0C13.6767 0 14.1267 0.45 14.1267 1V23.92C14.1267 24.47 13.6767 24.92 13.1267 24.92Z"
                fill="black"
            />
            <path
                d="M24.5867 13.4609H1.66675C1.11675 13.4609 0.666748 13.0109 0.666748 12.4609C0.666748 11.9109 1.11675 11.4609 1.66675 11.4609H24.5867C25.1367 11.4609 25.5867 11.9109 25.5867 12.4609C25.5867 13.0109 25.1367 13.4609 24.5867 13.4609Z"
                fill="black"
            />
        </Icon>
    )
}

export default PlusIcon
